import { Column, Grid } from "@carbon/react";
import { Link } from "react-router-dom";

import { Chart } from "./Chart";

export const ChartWithSummary = ({
  chartTitle,
  chartData,
  chartXAxisStartLabel,
  chartXAxisStopLabel,
  description,
  total,
  hasSummaryData,
  summaryRightTopTitle,
  summaryRightTopUrl,
  summaryRightTopText,
  summaryRightTopValue,
  summaryRightBottomTitle,
  summaryRightBottomUrl,
  summaryRightBottomText,
  summaryRightBottomValue,
}) => {
  return (
    <>
      <Column
        sm={4}
        md={hasSummaryData ? 6 : 4}
        lg={hasSummaryData ? 9 : 4}
        className="chart-with-summary--container"
      >
        <Chart
          data={chartData}
          title={chartTitle}
          total={total}
          description={description}
        />

        <div className="flex-container justify-content--sb">
          <small className="chart-label">{chartXAxisStartLabel}</small>
          <small className="chart-label">{chartXAxisStopLabel}</small>
        </div>
      </Column>

      {!hasSummaryData ? (
        <></>
      ) : (
        <Column sm={4} md={2} lg={3} className="chart-summary">
          <Column>
            <h6>
              <span className="font-ctm--semibold">{summaryRightTopTitle}</span>
              <Link to={summaryRightTopUrl} className="chart-link l1">
                View
              </Link>
              <br />
            </h6>

            <p>{summaryRightTopText}</p>
            <h3 className="font-ctm--semibold">{summaryRightTopValue}</h3>
          </Column>
          <br />
          <br />

          <Column>
            <h6>
              <span className="font-ctm--semibold">
                {summaryRightBottomTitle}
              </span>
              <Link to={summaryRightBottomUrl} className="chart-link l1">
                View
              </Link>
              <br />
            </h6>

            <p className="font-ctm--regular">{summaryRightBottomText}</p>
            <h3 className="font-ctm--semibold">{summaryRightBottomValue}</h3>
          </Column>
        </Column>
      )}
    </>
  );
};
